export const useAuth = () => {
    const accessToken = useCookie("access_token");
    return computed(() => !!accessToken.value);
};
